import React,{ Component } from 'react';
import { connect } from 'react-redux';
import { Table } from 'reactstrap';
import Actions from '../../../../../Actions';
import { getStatus, sanitizeData } from '../../../../../Utilities/Common';

class RowDeep extends Component{

    render(){
        let {vanity_id:id, location,type,assignee,priority,status,problem,HS,logs,user,created_at,comment,image } = sanitizeData(this.props.job);
        const jobStatus = getStatus(status);
        return (
            <div className="mb-3 p-3 border">
            <Table responsive bordered className="text-center">
                <tbody>
                    <tr>
                        <td><b>Niggle</b><br/>{id}</td><td><b>Type</b><br/>{type.name}</td><td><b>HS</b><br/>{HS === 1 ? <span>Yes</span>: "No"}</td>
                    </tr>
                    <tr>
                        <td><b>Age</b><br/>{created_at}</td><td><b>Location</b><br/>{location.name}</td><td><b>Status</b><br/>{jobStatus.name}</td>
                    </tr>
                    <tr>
                        <td><b>Priority</b><br/>{priority === 1 ? <span>URGENT</span>: "Medium"}</td><td><b>Created by</b><br/>{user.name}</td><td><b>Assigned to</b><br/>{assignee.name}</td>
                    </tr>
                </tbody>
            </Table>
            <b>Problem:</b> {problem}<br/><br/>
            <b>Comment:</b> {comment}<br/><br/>
            {!image.includes("default.jpg") && <React.Fragment><img width="250px" height="250px" src={image} /><br/><br/></React.Fragment>}
            <b>Status History</b><br/><br/>
            <Table responsive hover bordered className="text-center">
                <thead>
                    <tr>
                        <th>ID</th><th>User</th><th>Date</th><th>Status</th><th>Comment</th>
                    </tr>
                </thead>
                <tbody>
                    {logs.map((log,index) => {
                        const { user, created_at, status, comment } = sanitizeData(log);
                        return (
                        <tr key={index}><td>{index+1}</td><td>{user.name}</td><td>{created_at}</td><td>{getStatus(status).name}</td><td>{comment}</td></tr>
                        );
                    })}
                </tbody>
            </Table>

            </div>
        );
    }
}
const mapStateToProps = (state) => ({
    token: state.auth.token,
});
export default connect(mapStateToProps,Actions.jobs)(RowDeep);


// WEBPACK FOOTER //
// ./src/Components/App/Reports/Handyman/Level_2/RowDeep.js